<template>
  <div>
   <canvas id="bg-canvas"></canvas>
    <div class="gearbox">
      <div class="gear one">
        <div class="gear-inner">
          <div class="bar"></div>
          <div class="bar"></div>
          <div class="bar"></div>
        </div>
      </div>
      <div class="gear two">
        <div class="gear-inner">
          <div class="bar"></div>
          <div class="bar"></div>
          <div class="bar"></div>
        </div>
      </div>
      <div class="gear three">
        <div class="gear-inner">
          <div class="bar"></div>
          <div class="bar"></div>
          <div class="bar"></div>
        </div>
      </div>
      <div class="gear four large">
        <div class="gear-inner">
          <div class="bar"></div>
          <div class="bar"></div>
          <div class="bar"></div>
          <div class="bar"></div>
          <div class="bar"></div>
          <div class="bar"></div>
        </div>
      </div>
    </div>
    <div class="flexView_column main">
      <header class="flexView_center base">
        <img :src="logo" />
        <h2 class="flex">VueCore管理系统</h2>
      </header>
      <section class="flex loginbox">
        <div class="flexView_center bg"></div>
        <div class="window">
          <div class="avatar">
            <img :src="setAvatar" />
          </div>

          <div class="manager" v-show="isManager">
            <p class="userbase">{{setName}}</p>
            <p class="saying">世界因互联而美好,生活因互通而便捷,技术因共享而进步</p>
          </div>
          <div class="alert" :class="[isTipsClass ? 'success' : 'warm']" v-show="isTips">{{TipsMsg}}</div>
          <div class="form-group">
            <div class="input-group" v-show="isAccount">
              <span>账号</span>
              <input name="LogionName" v-model="userInfo.userName" type="text" placeholder="请输入管理员账号" />
            </div>
            <div class="input-group">
              <span>密码</span>
              <input name="LogionPassword" v-model="userInfo.passWord" type="password" placeholder="密码" />
            </div>
          </div>
          <div class="operating">
            <div class="login_btn login" @click="login">立即登录</div>
            <div class="login_btn yj_btn-warm switch" v-show="isLogOut" @click="logOut">切换用户</div>
          </div>
        </div>
      </section>
      <footer class="copyright">© Copyright 2021 youjiaapp dot Com Limited 版权所有。</footer>
    </div>
  </div>
</template>

<script>
import syslogo from "../assets/logo.png";
export default {

  data () {
    return {
      isTips:false,
      isAccount:false,
      isManager:false,
      isLogOut:false,
      isTipsClass:false,
      TipsMsg:"",
      setName:"",
      logo:syslogo,
      setAvatar:"",
      userInfo: { userName: "", passWord: "", checkbox: [] }
    }
  },
  methods: {
      login() {
        this.isTips=true; 
        if (this.userInfo.userName == "" || this.userInfo.userName.trim() == "")
          {
            
            this.TipsMsg="请输入登录账号"
            return;
          }

        if (this.userInfo.passWord == "" || this.userInfo.passWord.trim() == "")
         {
            
            this.TipsMsg="请输入登录密码"
            return;
         }
        this.http.post('api/AccessToken',
        {
          account: this.userInfo.userName,
          pw:this.userInfo.passWord
        }).then(res => {
            this.TipsMsg=res.msg;
            if (res.code == 200) {
                this.isTipsClass=true;//提示样式
                this.$store.commit('setUserInfo', res.data);
                  if (res.data.img !== "") {
                    this.setAvatar=this.$config.imgDomain+res.data.img
                  }
                  this.setName=res.data.username + res.data.level
                
                this.isLogOut=true;
                this.isAccount=false;//隐藏账号录入表单
                this.isManager=true;//显示用户名
                let that=this;
                setTimeout(function () {
                    that.isTips=false; 
                    that.$router.push({ path: "/" });
                }, 2000);
            }
          });
      },
      logOut(){
        
          this.$store.commit('clearUserInfo');
          this.isAccount=true;//显示账号录入表单
          this.isManager=false;//隐藏用户名
          this.isLogOut=false;
          this.setAvatar=this.$config.imgDomain+"/AdminStyle/images/defaultavatar.jpg";
      },
 

  },
  mounted () {
  
      var e = document.getElementById("bg-canvas"),
			o = document.documentElement.clientWidth,
			i = document.documentElement.clientHeight;
        e.width = o, e.height = i;
        var n = e.getContext("2d");
        n.strokeStyle = "#f6f6f6", n.lineWidth = 1, n.beginPath(), n.translate(.5, .5);
        for (t = 20; t <= i; t += 20) n.moveTo(0, t), n.lineTo(o, t);
        for (var t = 20; t <= o; t += 20) n.moveTo(t, 0), n.lineTo(t, i);
        e.style.width = "100%";
        e.style.height = "100%";
        n.closePath();
        n.stroke();

        if (this.$store.getters.getUserInfo()) {
            var getuserinfo = this.$store.getters.getUserInfo() //把字符串转换成JSON对象 
            this.isAccount=false;//隐藏账号录入表单
            this.isManager=true;//显示用户名
  
            if (getuserinfo.img != "") {
              this.setAvatar=this.$config.imgDomain+getuserinfo.img;
            }
            this.userInfo.userName=getuserinfo.account
            this.setName=getuserinfo.username + getuserinfo.level
            this.isLogOut=true;
        }
        else {
            this.isAccount=true;//显示账号录入表单
            this.isManager=false;//隐藏用户名
            this.isLogOut=false;
            this.$nextTick(() => {
              this.http.get("api/SysInitialize/SysBase").then(result => {
                  this.setAvatar=this.$config.imgDomain+result.sysConfig.weblogo
                  console.log(this.setAvatar)
                });
            })
              
        }
  }
}
</script>

<style scoped>
 body{min-width:inherit}
  .main {  width: 100%;  height:100vh; }
  #bg-canvas { position: absolute; z-index: -3; }
  .base {  height: 64px; background-color: #2b303b }
  .base h2 { color:#fff; font-size:2.4rem;  }
  .base img { height:60%; padding:0 20px;}
  .loginbox { position: relative; z-index:1;}
  .loginbox .bg { position: absolute; top: 0; left: 0; width: 100%; z-index: -1; height: 50%; color: #fff; background: #000033; background: url("../assets/img/ebg.jpg") 0 0 no-repeat;}
  .loginbox .window { width: 500px; background: rgba(255, 255, 255, 1); border: 1px solid #e5e5e5; margin: 50px auto; padding: 50px 50px;  }
  .loginbox .window .avatar { text-align: center; margin-bottom: 35px; }
  .loginbox .window .avatar img { width: 12.5rem; height: 12.5rem; border-radius: 50%; border: 1px solid #66afe9; }
  .loginbox .window .form-group { font-size: 1.5rem; margin-bottom: 35px; }
  .loginbox .window .form-group .input-group { border-bottom: 1px solid #e5e5e5; line-height: 4.0rem; margin-bottom: 1rem; }
  .loginbox .window .form-group .input-group input { font-size: 1.5rem; margin-left: 15px; line-height: 2.2rem; }
  .loginbox .window .alert {  padding: 1rem 0; margin-bottom: 1.5rem; font-size: 1.5rem; border-radius: 0.4rem; text-align: center;  }
  .loginbox .window .alert.warm { color: #a94442; background-color: #f2dede;}
  .loginbox .window .alert.success {color: #42a953; background-color: #def2e6; }
  .loginbox .window .manager { padding: 1rem 0; margin-bottom: 1.5rem; }
  .loginbox .window .manager .userbase { text-align:center; color:#555;  margin-bottom:0.3rem; font-size:2.0rem; border-bottom:1px rgba(0, 0, 0,.075) solid; padding-bottom:10px;}
  .loginbox .window .manager .saying{ text-align:center;color:#888; font-size:1.4rem;; padding:5px 0;}
  .loginbox .window .operating .login_btn { text-align: center; background-color: #0091e6; padding: 10px 0; font-size: 1.8rem; color: #fff; margin-top: 15px; border-radius: 5px; cursor:pointer }
  .loginbox .window .operating .yj_btn-warm { background-color: #FFB800; }

  .copyright { text-align: center; width:100%;  height:3rem; line-height:3rem; background-color: #2e3033;; color: #ccc; overflow:hidden }
  @-webkit-keyframes clockwise {
  0% {
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
  @-webkit-keyframes counter-clockwise {
  0% {
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -moz-transform: rotate(-360deg);
    -ms-transform: rotate(-360deg);
    -webkit-transform: rotate(-360deg);
    transform: rotate(-360deg);
  }
}
  .gearbox {
 position:absolute; 
 height:180px;
 bottom:64px; left:20px;
 opacity:0.1
}


.gear {
  position: absolute;
  height: 60px;
  width: 60px;
  -moz-box-shadow: 0px -1px 0px 0px #888888, 0px 1px 0px 0px black;
  -webkit-box-shadow: 0px -1px 0px 0px #888888, 0px 1px 0px 0px black;
  box-shadow: 0px -1px 0px 0px #888888, 0px 1px 0px 0px black;
  -moz-border-radius: 30px;
  -webkit-border-radius: 30px;
  border-radius: 30px;
}
.gear.large {
  height: 120px;
  width: 120px;
  -moz-border-radius: 60px;
  -webkit-border-radius: 60px;
  border-radius: 60px;
}
.gear.large:after {
  height: 96px;
  width: 96px;
  -moz-border-radius: 48px;
  -webkit-border-radius: 48px;
  border-radius: 48px;
  margin-left: -48px;
  margin-top: -48px;
}
.gear.one {
  top: 12px;
  left: 10px;
}
.gear.two {
  top: 61px;
  left: 60px;
}
.gear.three {
  top: 110px;
  left: 10px;
}
.gear.four {
  top: 13px;
  left: 128px;
}
.gear:after {
  content: "";
  position: absolute;
  height: 36px;
  width: 36px;
  -moz-border-radius: 36px;
  -webkit-border-radius: 36px;
  border-radius: 36px;
  background: #111111;
  top: 50%;
  left: 50%;
  margin-left: -18px;
  margin-top: -18px;
  z-index: 3;
  -moz-box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.1), inset 0px 0px 10px rgba(0, 0, 0, 0.1), inset 0px 2px 0px 0px #080808, inset 0px -1px 0px 0px #888888;
  -webkit-box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.1), inset 0px 0px 10px rgba(0, 0, 0, 0.1), inset 0px 2px 0px 0px #080808, inset 0px -1px 0px 0px #888888;
  box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.1), inset 0px 0px 10px rgba(0, 0, 0, 0.1), inset 0px 2px 0px 0px #080808, inset 0px -1px 0px 0px #888888;
}

.gear-inner {
  position: relative;
  height: 100%;
  width: 100%;
  background: #555555;
  -webkit-animation-iteration-count: infinite;
  -moz-animation-iteration-count: infinite;
  -moz-border-radius: 30px;
  -webkit-border-radius: 30px;
  border-radius: 30px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}
.large .gear-inner {
  -moz-border-radius: 60px;
  -webkit-border-radius: 60px;
  border-radius: 60px;
}
.gear.one .gear-inner {
  -webkit-animation: counter-clockwise 3s infinite linear;
  -moz-animation: counter-clockwise 3s infinite linear;
}
.gear.two .gear-inner {
  -webkit-animation: clockwise 3s infinite linear;
  -moz-animation: clockwise 3s infinite linear;
}
.gear.three .gear-inner {
  -webkit-animation: counter-clockwise 3s infinite linear;
  -moz-animation: counter-clockwise 3s infinite linear;
}
.gear.four .gear-inner {
  -webkit-animation: counter-clockwise 6s infinite linear;
  -moz-animation: counter-clockwise 6s infinite linear;
}
.gear-inner .bar {
  background: #555555;
  height: 16px;
  width: 76px;
  position: absolute;
  left: 50%;
  margin-left: -38px;
  top: 50%;
  margin-top: -8px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  border-right: 1px solid rgba(255, 255, 255, 0.1);
}
.large .gear-inner .bar {
  margin-left: -68px;
  width: 136px;
}
.gear-inner .bar:nth-child(2) {
  -moz-transform: rotate(60deg);
  -ms-transform: rotate(60deg);
  -webkit-transform: rotate(60deg);
  transform: rotate(60deg);
}
.gear-inner .bar:nth-child(3) {
  -moz-transform: rotate(120deg);
  -ms-transform: rotate(120deg);
  -webkit-transform: rotate(120deg);
  transform: rotate(120deg);
}
.gear-inner .bar:nth-child(4) {
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}
.gear-inner .bar:nth-child(5) {
  -moz-transform: rotate(30deg);
  -ms-transform: rotate(30deg);
  -webkit-transform: rotate(30deg);
  transform: rotate(30deg);
}
.gear-inner .bar:nth-child(6) {
  -moz-transform: rotate(150deg);
  -ms-transform: rotate(150deg);
  -webkit-transform: rotate(150deg);
  transform: rotate(150deg);
}
</style>



// WEBPACK FOOTER //
// src/views/login.vue